import { Experiment } from '@naturalcycles/shared'
import { QuizPage } from '@src/app/cnst/quiz/quiz-pages.cnst.js'
import { QuizModifier } from '@src/app/util/quiz.util.js'
import { QuizSections } from '@src/typings/quiz.enum.js'
import { AppQuizEngineConfig, AppQuizFlow, QuizSignatureObject } from '@src/typings/quiz.model.js'
import { birthControlMethodOuraSyncABTest } from './breakpoints/birth-control-method.breakpoint.js'
import { conceiveTimingOuraSyncABTest } from './breakpoints/conceive-timing.breakpoint.js'
import { hormonalBirthControlUsageOuraSyncABTest } from './breakpoints/hormonal-birth-control-usage.breakpoint.js'
import { addLastPeriodDatesOuraSyncABTest } from './breakpoints/last-period.breakpoint.js'

class ExpOuraSyncABTestQuiz implements QuizModifier<AppQuizEngineConfig> {
  public _shouldEnhance(obj: QuizSignatureObject): boolean {
    const experiment = obj.experiment[Experiment.OURA_SYNC_BEFORE_PAYMENT_V2]
    return !!experiment && ['test', 'test2'].includes(experiment)
  }

  public enhanceEngineConfig(
    obj: QuizSignatureObject,
    config: AppQuizEngineConfig,
  ): AppQuizEngineConfig {
    if (!this._shouldEnhance(obj)) return config
    config.guardData = {
      ...config.guardData,
      [QuizPage.lastPeriodDate0]: state => !!state?.avgCycleLength,
      [QuizPage.lastPeriodDate1]: state => !!state?.lastPeriodDates && !!state?.lastPeriodDates[0],
      [QuizPage.lastPeriodDate2]: state => !!state?.lastPeriodDates && !!state?.lastPeriodDates[1],
      [QuizPage.lastPeriodDate3]: state => !!state?.lastPeriodDates && !!state?.lastPeriodDates[2],
      [QuizPage.lastPeriodDate4]: state => !!state?.lastPeriodDates && !!state?.lastPeriodDates[3],
      [QuizPage.lastPeriodDate5]: state => !!state?.lastPeriodDates && !!state?.lastPeriodDates[4],
    }

    config.breakpointActions.birthControlMethod = birthControlMethodOuraSyncABTest
    config.breakpointActions.hormonalBirthControlUsage = hormonalBirthControlUsageOuraSyncABTest
    config.breakpointActions.lastPeriodDates = addLastPeriodDatesOuraSyncABTest
    config.breakpointActions.conceiveTiming = conceiveTimingOuraSyncABTest

    return config
  }

  public enhanceSections(obj: QuizSignatureObject, sections: QuizSections): QuizSections {
    if (!this._shouldEnhance(obj)) return sections

    return sections
  }

  public enhanceInitialFlow(obj: QuizSignatureObject, flow: AppQuizFlow): AppQuizFlow {
    if (!this._shouldEnhance(obj)) return flow
    return flow
  }

  public enhanceEntry(obj: QuizSignatureObject, entry: QuizPage | null): QuizPage | null {
    if (!this._shouldEnhance(obj)) return entry
    return entry
  }

  public enhanceExit(obj: QuizSignatureObject, exit: QuizPage | null): QuizPage | null {
    if (!this._shouldEnhance(obj)) return exit
    return exit
  }
}

export const expOuraSyncABTestQuiz = new ExpOuraSyncABTestQuiz()
